import React, {Component} from 'react';
import { Text } from 'react-konva';
import {
  textareaFontColor,
} from '../../../library/constants';
import {
  isMobilePhone,
} from '../../../library/calc';

/*
export const Vsum = ({
    vsum,
    matchBubbleContent,
    left,
    top,
    leftStart4Boxes,
    topMatchLabel,
    fontSizeMatchLabel,
    fontFamilyMatchLabel,
    stopStageClickPropagation,
  }) => {
    left += leftStart4Boxes;
    top += topMatchLabel + 9.9;

    return <Text
      x={left}
      y={top}
      text={( typeof(matchBubbleContent) !== 'undefined' ? matchBubbleContent: vsum)}
      fontSize={fontSizeMatchLabel}
      fontFamily={fontFamilyMatchLabel}
      fill={textareaFontColor}
      width={60}
      align={'center'}
      onTouchStart={()=>{
        stopStageClickPropagation({fromWhere:'bubble vsum A'});
      }}
      onClick={()=> {
        if(isMobilePhone() ) return;
        stopStageClickPropagation({fromWhere:'bubble vsum B'});}}
    />;
  };

*/

export class Vsum extends Component {

  componentDidMount(){

  }

  componentDidUpdate(){

  }

  render () {

    const {
      vsum,
      leftStart4Boxes,
      topMatchLabel,
      fontSizeMatchLabel,
      fontFamilyMatchLabel,
      stopStageClickPropagation,
    } = this.props

    let {
      matchBubbleContent,
      matchBubbleContentVarStr,
      left,
      top,
    } = this.props

    left += leftStart4Boxes;
    top += topMatchLabel + 9.9;

    matchBubbleContent = ( typeof(window.trl) !== 'undefined' ? window.trl(matchBubbleContent, null, {count: matchBubbleContentVarStr}): matchBubbleContent);

    const vSumText = ( matchBubbleContent !== '' ? matchBubbleContent: vsum);

    return (
      <Text
        x={left}
        y={top}
        text={vSumText}
        fontSize={fontSizeMatchLabel}
        fontFamily={fontFamilyMatchLabel}
        fill={textareaFontColor}
        width={60}
        align={'center'}
        onTouchStart={()=>{
          stopStageClickPropagation({fromWhere:'bubble vsum A'});
        }}
        onClick={()=> {
          if(isMobilePhone() ) return;
          stopStageClickPropagation({fromWhere:'bubble vsum B'});}}
      />
    );
  }
}
